import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';

const styles = {
  link: {
    margin: '5px 5px'
  }
};

const enhance = compose();

const button = enhance(({ classes, disabled }) => {
  const domain = window.location.hostname;
  return !disabled ? (
    <Link
      href={`https://dashboard.stripe.com/oauth/authorize?response_type=code&client_id=${
        process.env.REACT_APP_STRIPE_CLIENT_ID
      }&scope=read_write&redirect_uri=https://${domain}/api/v1.0/stripeAccounts`}
      target="_blank"
      rel="noreferrer"
      className={classes.link}
    >
      <img
        src={`${process.env.PUBLIC_URL}/images/stripe.png`}
        alt="Stripe Button"
      />
    </Link>
  ) : (
    <img
      src={`${process.env.PUBLIC_URL}/images/stripe_dis.png`}
      alt="Stripe Button"
    />
  );
});

export default withRouter(withStyles(styles)(button));
